import {Component, OnDestroy, OnInit} from '@angular/core';
import {firstValueFrom, Subscription} from "rxjs";
import {DjangoApiService} from "../../../../shared/services/django-api.service";
import {LanguageService} from "../../../../shared/services/language.service";
import {LangChangeEvent, TranslateService} from "@ngx-translate/core";
import {ActivatedRoute} from "@angular/router";
import {SectionListComponent} from "../../../sections/public/section-list/section-list.component";
import {CardsBasicComponent} from "../../../../shared/components/cards/cards-basic/cards-basic.component";
import {MatButton} from "@angular/material/button";
import {PdfService} from "../../../../shared/services/pdfMake/pdf.service";
import {BenchmarkDetailComponent} from "../../../benchmarks/public/benchmark-detail/benchmark-detail.component";
import {PeriodDetailComponent} from "../../../periods/public/period-detail/period-detail.component";
import * as Plotly from 'plotly.js-dist-min';
import {ChartDataService} from "../../../../shared/services/plotly/chart-data.service";
import {PlotlyService} from "../../../../shared/services/plotly/plotly.service";
import {PdfForPageService} from "../../../../shared/services/pdfMake/pdf-for-page.service";
import {ReportListPublicComponent} from "../../../reports/public/report-list-public/report-list-public.component";
import {SubscribtionsComponent} from "../../../users/subscribtions/subscribtions.component";

@Component({
  selector: 'app-page-detail',
  standalone: true,
  imports: [
    SectionListComponent,
    CardsBasicComponent,
    MatButton,
    BenchmarkDetailComponent,
    PeriodDetailComponent,
    ReportListPublicComponent,
    SubscribtionsComponent
  ],
  templateUrl: './page-detail.component.html',
  styleUrl: './page-detail.component.css'
})
export class PageDetailComponent implements OnInit, OnDestroy {
  pageSlug!: any;
  productSlug!: any;
  pageData!: any;
  reportListData: any[] = [];
  currentLanguage!: string;
  langChangeSubscription: Subscription | null = null;

  selectedBenchmarks!: any;
  selectedperiods!: any;

  private subscriptions: Subscription = new Subscription();


  constructor(
    private _apiService: DjangoApiService,
    private _languageService: LanguageService,
    private _translate: TranslateService,
    private _route: ActivatedRoute,
    private _pdfService: PdfService,
    private _plotlyService: PlotlyService,
    private _chartDataService: ChartDataService,
    private _pdfForPageService: PdfForPageService
  ) {}

  ngOnInit() {
    this.setupLanguageSubscription();
    this.getRouteParams();
  }

  private setupLanguageSubscription(): void {
    this.currentLanguage = this._languageService.getLanguage();
    this.subscriptions.add(
      this.langChangeSubscription = this._translate.onLangChange.subscribe((event: LangChangeEvent) => {
        this.currentLanguage = event.lang;
      })
    );
  }

  private getRouteParams(): void {
    this._route.params.subscribe(params => {
      this.pageSlug = params['pageSlug'];

      this._route.parent?.params.subscribe(parentParams => {
        this.productSlug = parentParams['productSlug'];
        this.loadPageData();
      });
    });
  }

  private loadPageData(): void {
    this.subscriptions.add(
      this._apiService.fetchPage(this.pageSlug, this.productSlug).subscribe({
        next: (response: any) => {
          this.pageData = response;
        },
        error: (error: any) => {
          console.error('There was an error fetching the user information', error);
        }
      })
    );
  }

  onSelectedBenchmarksChange(selectedBenchmarks: any) {
    this.selectedBenchmarks = selectedBenchmarks;
  }

  onSelectedPeriodsChange(selectedPeriods: any) {
    this.selectedperiods = selectedPeriods;
  }

  generatePdf(){
    this._pdfService.generatePdf();
  }

  // In page-detail.component.ts
  public generatePdfForPage(targetPageSlug: string, productSlug: string, dateString: string) {
    this._pdfForPageService.generatePdfForPage(targetPageSlug, productSlug, dateString);
  }


  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

}
